import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'petastiKentima';
const args = {};

export class PetastiKentima extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
